import React from 'react';
export function NervousSystemFreeze() {
  return <div className="w-full my-12" data-id="element-257">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-258">
        This is why therapy, mindset work, and breathing exercises can feel so
        frustratingly useless for someone in freeze:
      </h2>
      <div className="space-y-6 mt-8" data-id="element-259">
        <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-purple-400" data-id="element-260">
          <p className="text-gray-700" data-id="element-261">
            <span className="font-bold" data-id="element-262">•</span> Therapy asks you to talk your
            way into feeling—but talking won't reawaken a nervous system that's
            shut down.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-teal-400" data-id="element-263">
          <p className="text-gray-700" data-id="element-264">
            <span className="font-bold" data-id="element-265">•</span> Mindset and journaling ask you
            to think your way back to feeling—but your emotional numbness isn't
            in your thoughts, it's in your body's physiology.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-purple-400" data-id="element-266">
          <p className="text-gray-700" data-id="element-267">
            <span className="font-bold" data-id="element-268">•</span> Breathwork and meditation
            require you to access sensation—but freeze mode specifically
            disconnects you from bodily sensation as a protective mechanism.
          </p>
        </div>
      </div>
      <div className="mt-8 text-lg text-gray-700 space-y-4" data-id="element-269">
        <p data-id="element-270">
          And until your nervous system feels genuinely safe enough to thaw out,
          reconnecting with emotions will continue to feel impossible.
        </p>
        <p data-id="element-271">
          You haven't failed any method you've tried before. Those methods have
          simply been trying to solve the wrong problem.
        </p>
        <p data-id="element-272">
          Your body needs something entirely different. Something gentle, safe,
          and deeply creative—something capable of reaching a nervous system
          that words, breathing, and even meditation can't touch.
        </p>
      </div>
      <div className="w-full my-8" data-id="element-273">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hieBwQr6Wjcnm1Ydj6Fg3w/Mockups_%2818%29.png" alt="Expressive rewiring techniques demonstration" className="w-full max-w-2xl mx-auto h-auto object-cover rounded-lg shadow-md" data-id="element-274" />
      </div>
    </div>;
}